export function assembleSSE(text) {
  let out = '';
  (text || '').split(/\r?\n/).forEach((line) => {
    if (!line.startsWith('data:')) return;
    const data = line.slice(5).trim();
    if (!data || data === '[DONE]') return;
    try {
      const obj = JSON.parse(data);
      (obj.choices || []).forEach((ch) => {
        if (ch.delta && typeof ch.delta.content === 'string') out += ch.delta.content;
        else if (typeof ch.text === 'string') out += ch.text;
      });
    } catch (_) {
      /* not JSON: skip */
    }
  });
  return out;
}

export function prettyBody(text) {
  try {
    return JSON.stringify(JSON.parse(text), null, 2);
  } catch (_) {
    return text;
  }
}

export function base64ToBlob(b64, type) {
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return new Blob([bytes], { type: type || 'application/octet-stream' });
}

// OpenAI-style streams read best assembled; anything else (e.g. Anthropic events) starts raw.
export function defaultStreamView(text) {
  return assembleSSE(text) ? 'assembled' : 'raw';
}

// Revoke later: revoking right after click() can cancel the download in Firefox/Safari.
export function saveBlob(blob, name, urlApi = URL) {
  const url = urlApi.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  setTimeout(() => urlApi.revokeObjectURL(url), 1000);
}
